import { isStringNumber, isStringLengthThanEqual } from '.'

/**
 * Is value valid phone code. e.q: +44
 * @param {string} stringPhoneNumber
 * @returns {boolean}
 */
export const isPhoneCode = (stringPhoneNumber) => {
  const code = stringPhoneNumber.slice(1)
  return stringPhoneNumber[0] === '+' && isStringLengthThanEqual(stringPhoneNumber, 4) && isStringNumber(code)
}
